import React, { memo } from 'react'

import withHide from 'components/withHide'
import { All_GAME_CATEGORY_SLUG } from 'containers/App/constants'
import type { Category } from 'containers/GamesBlock/types'
import useCategories from 'utils/hooks/queries/games/useCategories'

import { GamesCategory } from './GamesCategory'

function CategoriesGridComponent() {
  const { data: categories } = useCategories()

  if (!categories) {
    return null
  }

  return (
    <>
      {categories
        .filter(({ slug }) => slug !== All_GAME_CATEGORY_SLUG)
        .map((category: Category) => (
          <GamesCategory
            key={category.slug}
            category={category}
          />
        ))}
    </>
  )
}

export const CategoriesGrid = withHide(memo(CategoriesGridComponent))
